import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
// Models
import { DatePipe } from "@angular/common";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER } from "@angular/cdk/keycodes";

import { Attachment } from "./../../models/attachment";
import { Club } from "./../../models/club";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import * as lodash from "lodash";
import { OAuthService } from "app/services/o-auth";
@Component({
  templateUrl: "./create.event.component.html",
})
export class CreateEventComponent implements OnInit {
  public form: FormGroup;
  public offerData: any;
  // public orderData: any;
  public attachmentFiles: any;
  public loading: boolean;
  private attachment: Attachment;
  private attachmentExt: string;
  public minFrom: any;
  public minTill: any;
  public minEndDate: Date;
  private orginalAttachment: Attachment;
  public isBankAttached: boolean = false;
  public adminData: any;
  public imageLoader: boolean = false;
  public variants: Array<any>;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  public skus: Array<any>;
  public isVarientSubmit = false;
  public benefits: Array<any>;
  public features: Array<any>;
  public user: any;

  constructor(
    private router: Router,
    private firebase: FirebaseApp,
    private datePipe: DatePipe,
    private fireAuth: AngularFireAuth,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase
  ) {
    this.form = new FormGroup({
      offerName: new FormControl("", Validators.required),
      validFrom: new FormControl("", Validators.required),
      validTill: new FormControl("", Validators.required),
      eventDate: new FormControl("", Validators.required),
      stock: new FormControl({ value: "", disabled: false }),
      offerType: new FormControl(3, Validators.required),
      sellingPrice: new FormControl(0),
      offerPrice: new FormControl(0, Validators.required),
      shippingPrice: new FormControl("0"),
      shortDescription: new FormControl("", Validators.required),
      longDescription: new FormControl(""),
      creationDate: new FormControl(moment().unix()),
      tnc: new FormControl("", Validators.required),
      isAdmin: new FormControl(false, Validators.required),
      isStockUnlimited: new FormControl(false),
      deliveryDays: new FormControl(""),
    });
    this.benefits = [];
    this.features = [];

    this.attachmentFiles = {};
    this.user = this.oAuthService.getClub();

    this.offerData = {
      offerName: "",
      validFrom: "",
      validTill: "",
      eventDate: "",
      offerType: 3,
      userOfferId: "",
      images: [],
      sellingPrice: "",
      offerPrice: "",
      shippingPrice: 0,
      sold: 0,
      status: 3,
      stock: "",
      shortDescription: "",
      userId: this.user.uid,
      uid: this.user.cid,
      longDescription: "",
      creationDate: moment().unix(),
      tnc: "",
      isAdmin: false,
      isStockUnlimited: true,
      club: {
        cid: "",
        clubName: "",
        email: "",
        phone: "",
        clubImage: "",
        city: "",
        country: "",
        state: "",
        location: {},
      },
      eventClub: {
        cid: "",
        clubName: "",
        email: "",
        phone: "",
        clubImage: "",
        city: "",
        country: "",
        state: "",
        location: {},
      },
    };
    this.variants = [];

    this.minFrom = new Date();
    this.minTill = new Date();
    this.form.get("validFrom").valueChanges.subscribe((val) => {
      this.offerData.validFrom = this.datePipe.transform(val, "yyyy-MM-dd");
      this.minTill = val;
    });

    this.form.get("validTill").valueChanges.subscribe((val) => {
      this.offerData.validTill = this.datePipe.transform(val, "yyyy-MM-dd");
    });
    this.form.get("eventDate").valueChanges.subscribe((val) => {
      this.offerData.eventDate = this.datePipe.transform(val, "yyyy-MM-dd");
    });
    this.form.get("isStockUnlimited").valueChanges.subscribe((val) => {
      if (val) {
        this.form.get("stock").disable();
      } else {
        this.form.get("stock").enable();
      }
    });

    if (this.user.type == 3) {
      this.offerData.isAdmin = true;
      this.form.controls.isAdmin.setValue(true);
    }
    this.changeClub(this.user);
  }
  ngOnInit(): void {}

  changeClub = function (club) {
    if (club.type == 3 || club.bank) {
      if (club.type == 3 || club.bank.stripe_user_id) {
        let cid = club.cid ? club.cid : club.$key;
        this.offerData.club.cid = cid;
        this.offerData.club.clubName = club.name ? club.name : club.fullName;
        this.offerData.club.location = club.location;
        this.offerData.club.city = club.city;
        this.offerData.club.state = club.state;
        this.offerData.club.country = club.country;
        if (club.avatar_thumb) {
          this.offerData.club.clubImage = club.avatar_thumb;
        }
        if (club.email) {
          if (this.user.type == 1) {
            this.fireDatabase.object(`/users/` + cid).subscribe((result) => {
              this.offerData.club.email = result.email;

              if (result.db_phone) {
                this.offerData.club.phone = result.db_phone;
              }
      
              if (result.phone) {
                this.offerData.club.phone = result.phone;
              }
            });
          } else {
            this.offerData.club.email = club.email;
          }
        }
      }
      if (this.user.type != 3) {
        this.isBankAttached = false;
      }
    } else {
      if (this.user.type != 3) {
        this.isBankAttached = true;
      }
    }
  };

  changeClub1 = function (club) {
    if (club) {
      let cid = club.cid ? club.cid : club.$key;
      this.offerData.eventClub.cid = cid;
      this.offerData.eventClub.clubName = club.name;
      this.offerData.eventClub.location = club.location;
      this.offerData.eventClub.city = club.city;
      this.offerData.eventClub.state = club.state;
      this.offerData.eventClub.country = club.country;
      this.offerData.eventClub.address = club.address
        ? club.address
        : club.city && club.country
        ? club.city + " " + club.country
        : "";
      if (club.avatar_thumb)
        this.offerData.eventClub.clubImage = club.avatar_thumb;
      if (club.email) this.offerData.eventClub.email = club.email;
      if (club.db_phone) this.offerData.eventClub.phone = club.db_phone;
      if (club.phone) this.offerData.eventClub.phone = club.phone;
      if (club.state) this.offerData.eventClub.state = club.state;
      if (club.country) this.offerData.eventClub.country = club.country;
    }
  };

  private uploadFile(): Promise<any> {
    var promises = [];
    if (this.attachmentFiles && this.attachmentFiles.cropped) {
      for (var i = 0; i < this.attachmentFiles.cropped.length; i++) {
        const element = this.attachmentFiles.cropped[i];
        const newImage = new Promise((resolve, reject) => {
          const filename = `${moment().unix()}.${Math.floor(
            Math.random() * 900 + 100
          )}`;
          this.firebase
            .storage()
            .ref(`/attachments/${this.fireAuth.auth.currentUser.uid}`)
            .child(filename)
            .put(element.file)
            .then((result) => resolve(result))
            .catch((error) => reject(error));
          console.log(filename);
        });
        promises.push(newImage);
        console.log(newImage);
      }
    }
    return Promise.all(promises);
  }

  public changeAttachment(attachments) {
    this.attachmentFiles = attachments;
  }

  public submit() {
    const date = moment(new Date()).format("YYYY-MM-DD");
    const currentTime = new Date().getTime();
    const validFrom = Date.parse(this.offerData.validFrom);
    if (currentTime >= validFrom) {
      this.offerData.status = 1;
    }
    if (this.user.type == 3) {
      this.updateDatabase();
    } else {
      if (!this.isBankAttached) {
        this.updateDatabase();
      } else {
        alert("Connect with Stripe");
      }
    }
  }

  submitUnlimited() {
    console.log(this.offerData.shippingPrice);
    if (this.offerData.shippingPrice == 0) {
      this.offerData.stock = 0;
    }
  }

  private updateDatabase() {
        console.log(this.offerData);
    this.offerData.offerName = this.form.controls["offerName"].value;
    this.offerData.offerType = parseInt(this.form.controls["offerType"].value);
    this.offerData.stock = this.form.controls["stock"].value;
    this.offerData.sellingPrice = this.form.controls["sellingPrice"].value;
    this.offerData.offerPrice = this.form.controls["offerPrice"].value;
    this.offerData.shippingPrice = parseFloat(
      this.form.controls["shippingPrice"].value
    );
    this.offerData.shortDescription = this.form.controls[
      "shortDescription"
    ].value;
    this.offerData.longDescription = this.form.controls[
      "longDescription"
    ].value;
    this.offerData.tnc = this.form.controls["tnc"].value;
    this.offerData.isAdmin = this.form.controls["isAdmin"].value;
    this.offerData.isStockUnlimited = this.form.controls[
      "isStockUnlimited"
    ].value;

    let temp = this.offerData.isStockUnlimited == false && !this.offerData.stock;
    if(temp)
    {
      alert("Please fill stocks count");
      return;
    }

    this.imageLoader = true;
    if (
      this.offerData.sellingPrice == null ||
      this.offerData.sellingPrice == undefined ||
      this.offerData.sellingPrice == ""
    ) {
      this.offerData.sellingPrice = this.offerData.offerPrice;
    }
    if (this.offerData.isStockUnlimited) {
      this.offerData.stock = 10000;
    }

    if (!this.offerData.club.country) {
      delete this.offerData.club.country;
    }

    if (!this.offerData.club.location) {
      delete this.offerData.club.location;
    }

    if (this.offerData.club.phone == "") {
      delete this.offerData.club.phone;
    }

    if (!this.offerData.club.city) {
      delete this.offerData.club.city;
    }

    if (!this.offerData.club.state) {
      delete this.offerData.club.state;
    }
    if (this.user.type == 1) {
      this.offerData.eventClub = this.offerData.club;
    }

    if (!this.offerData.eventClub.cid || this.offerData.eventClub.cid == "") {
      alert("Please select event club");
      this.imageLoader = false;
      return;
    }

    if (
      !this.offerData.eventClub.clubName ||
      this.offerData.eventClub.clubName == ""
    ) {
      alert("Please select event club");
      this.imageLoader = false;
      return;
    }

    if (
      !this.attachmentFiles.cropped ||
      this.attachmentFiles.cropped.length == 0
    ) {
      alert("Please select image");
      this.imageLoader = false;
      return;
    }

    this.fireDatabase.list(`/user-offers/${this.offerData.club.cid}`).subscribe(
      (result: Array<any>) => {
        let length = result.length;
        ++length;
        if (this.user.type == 3) {
          if (length < 10) {
            this.offerData.userOfferId = "GOLFHUBBER" + "-0" + length;
          } else {
            this.offerData.userOfferId = "GOLFHUBBER" + "-" + length;
          }
        } else {
          let eventId = "";
          if (this.offerData.club.clubName) {
            let splited = this.offerData.club.clubName.split(" ");
            splited.map((x) => {
              eventId = eventId + x.substring(0, 2);
            });
          }
          if (length < 10) {
            this.offerData.userOfferId = eventId + "-0" + length;
          } else {
            this.offerData.userOfferId = eventId + "-" + length;
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );

    this.uploadFile()
      .then((fileResult) => {
        var urls = [];
        for (var i = 0; i < fileResult.length; i++) {
          var element = fileResult[i];
          urls.push(element.downloadURL);
        }
        this.offerData.image = urls[0];
        this.offerData.images = urls;
        if (this.user.type == 3) {
          this.offerData.isAdmin = true;
        } else {
          this.offerData.isAdmin = false;
        }

        this.offerData.createdBy = this.user.type;
        this.fireDatabase.database
          .ref(`/user-offers/${this.offerData.club.cid}/`)
          .push(this.offerData)
          .then((postResult) => {
            this.fireDatabase.database
              .ref(`/index/offers/${postResult.key}`)
              .set(this.offerData.club.cid)
              .then(() => {
                switch (this.offerData.offerType) {
                  case 1:
                    alert("Voucher Created Successfully");
                    break;
                  case 2:
                    alert("Product Created Successfully");
                    break;
                  case 3:
                    alert("GH Event Created Successfully");
                    break;
                }
                this.imageLoader = false;
                this.router.navigate(["/components/events"]);
              })
              .catch((error) => {
                this.imageLoader = false;
                this.error(error);
              });
          })
          .catch((error) => {
            this.error(error);
          });
      })
      .catch((error) => {
        this.error(error);
      });
  }
  private error(error): void {
    console.error(error);
    alert("Sorry, something went wrong!");
    this.loading = false;
    this.imageLoader = false;
  }
  public addVariant() {
    this.variants.push({
      option: "",
      values: [],
    });
  }

  public removeVariant(index) {
    this.variants.splice(index);
  }
  add(event: MatChipInputEvent, index): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || "").trim()) {
      let t = this.variants[index].values.find(
        (q) =>
          q.name.trim().toLocaleLowerCase() == value.trim().toLocaleLowerCase()
      );
      if (!t)
        this.variants[index].values.push({
          name: value.trim(),
          option: this.variants[index].option,
        });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(child, parent): void {
    this.variants[parent].values.splice(child, 1);
  }
  public resetVariant() {
    if (confirm("All Sku data will be deleted")) {
      this.isVarientSubmit = false;
      this.skus = [];
    }
  }
  submitVariant() {
    let array = [];
    this.variants.map((v) => {
      v.id = this.fireDatabase.database.ref().push().key;
      v.values.map((o) => {
        o.id = this.fireDatabase.database.ref().push().key;
        o.optionId = v.id;
      });
      array.push(v.values);
      return v;
    });

    let results = [[]];
    for (let i = 0; i < array.length; i++) {
      let currentSubArray = array[i];
      let temp = [];
      for (let j = 0; j < results.length; j++) {
        for (let k = 0; k < currentSubArray.length; k++) {
          temp.push(results[j].concat(currentSubArray[k]));
        }
      }
      results = temp;
    }
    console.log(array);
    console.log(results);

    this.skus = [];
    this.isVarientSubmit = true;
    for (let q = 0; q < results.length; q++) {
      const element = results[q];
      this.skus.push({
        stock: (this.offerData.stock = this.form.controls["stock"].value),
        isStockUnlimited: this.form.controls["isStockUnlimited"].value,
        offerPrice: this.form.controls["offerPrice"].value,
        sellingPrice: this.form.controls["sellingPrice"].value
          ? this.form.controls["sellingPrice"].value
          : this.form.controls["offerPrice"].value,
        variantCombinations: element,
        images: [],
      });
    }
    console.log(this.skus);

    console.log(this.variants);
  }
  removeSku(index) {
    this.skus.splice(index, 1);
  }

  arrayToObject = (array, keyField) =>
    array.reduce((obj, item) => {
      obj[item[keyField]] = item.id;
      return obj;
    }, {});

  addBenefit(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || "").trim()) {
      let t = this.benefits.find(
        (q) =>
          q.name.trim().toLocaleLowerCase() == value.trim().toLocaleLowerCase()
      );
      if (!t) this.benefits.push({ name: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  removeBenefit(child): void {
    this.benefits.splice(child, 1);
  }
  addFeature(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || "").trim()) {
      let t = this.features.find(
        (q) =>
          q.name.trim().toLocaleLowerCase() == value.trim().toLocaleLowerCase()
      );
      if (!t) this.features.push({ name: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  removeFeature(child): void {
    this.features.splice(child, 1);
  }
}
